<div class="component is-3d is-pointer-events-none" [ngClass]="{'is-empty': isEmpty}"
  [style.width.px]="size * gridSize"
  appMovable [movable.option]="movableOption" (movable.ondragstart)="onMove()" (movable.ondragend)="onMoved()">
  <div class="is-pointer-events-auto is-grab"
       appRotable [rotable.option]="rotableOption" (rotable.ondragstart)="onMove()" (rotable.ondragend)="onMoved()">
    <div *ngIf="topCard && imageFile && name != '峡谷'" (@shuffle.start)="animationShuffleStarted($event)" (@shuffle.done)="animationShuffleDone($event)"
         [@shuffle]="animeState">
      <img class="card-image" [ngStyle]="{'transform': 'rotateZ(' + topCard.rotate +'deg)'}" [src]="imageFile.url | safe: 'resourceUrl'">
    </div>
    <div *ngIf="topCard && imageFile && name == '峡谷' && cards.length != 1" (@shuffle.start)="animationShuffleStarted($event)" (@shuffle.done)="animationShuffleDone($event)"
         [@shuffle]="animeState">
      <img class="card-image" [ngStyle]="{'transform': 'rotateZ(' + topCard.rotate +'deg)'}" [src]="imageFile.url | safe: 'resourceUrl'">
    </div>
    <div *ngIf="topCard && imageFile && name == '峡谷' && cards.length == 1" (@shuffle.start)="animationShuffleStarted($event)" (@shuffle.done)="animationShuffleDone($event)"
         [@shuffle]="animeState">
      <img class="card-image gray-out" [ngStyle]="{'transform': 'rotateZ(' + topCard.rotate +'deg)'}" [src]="imageFile.url | safe: 'resourceUrl'">
    </div>
    <ng-container *ngIf="!isIconHidden">
      <!--<div class="rotate-grab of-left-top">
      <i class="material-icons">autorenew</i>
    </div>
    <div class="rotate-grab of-left-bottom">
      <i class="material-icons">autorenew</i>
    </div>
    <div class="rotate-grab of-right-bottom">
      <i class="material-icons">autorenew</i>
    </div>
    <div class="rotate-grab of-right-top">
      <i class="material-icons">autorenew</i>
    </div>-->
    </ng-container>
    <div *ngIf="cardStack.name != '奥義駒' &&  cardStack.name != '峡谷' && isShowTotal" class="name-tag is-nowrap is-black-background" [ngStyle]="{'transform': 'translateY(100%) translateX(-50%) translateX(' + size * gridSize / 2 +'px)'}">
      <span>{{cards.length}}</span>
    </div>
    <div *ngIf="cardStack.name == '峡谷' && isShowTotal" class="name-tag is-nowrap is-black-background" [ngStyle]="{'transform': 'translateY(90%) translateX(-50%) translateX(' + size * gridSize / 2 +'px) '}">
      <span>{{cards.length - 1}}</span>
    </div>
    <!--<div *ngIf="cardStack.name == '峡谷' && isShowTotal" class="name-tag is-nowrap is-black-background" [ngStyle]="{'transform': 'translateY(90%) translateX(-110%) translateX(' + size * gridSize / 2 +'px) '}">
      <span>{{cards.length - 1}}</span>
    </div>-->
    <!--<div *ngIf="cardStack.name == '峡谷' && isShowTotal" class="name-tag is-nowrap is-red-background" [ngStyle]="{'transform': 'translateY(90%) translateX(10%) translateX(' + size * gridSize / 2 +'px) '}">
    <span>{{count}}</span>
  </div>-->
    <div *ngIf="cardStack.name == '奥義駒' && isShowTotal" class="name-tag is-nowrap is-black-background" [ngStyle]="{'transform': 'translateY(-200%) translateX(-50%) translateX(' + size * gridSize / 2 +'px)'}">
      <span>{{cards.length}}</span>
    </div>
    <div *ngIf="hasOwner" class="name-tag is-nowrap is-black-background" [ngStyle]="{'transform': 'translateY(-190%) translateX(-50%) translateX(' + size * gridSize / 2 +'px)'}">
      <span>{{ownerName}}が確認中</span>
    </div>
  </div>
</div>
